export const events = {
    productOpened: {
        name: "Product Opened",
        requiredFields: ["product", "universitySlug"],
    },
    productClosed: {
        name: "Product Closed",
        requiredFields: ["product", "universitySlug"],
    },
    questionPromptClicked: {
        name: "Question Prompt Clicked",
        requiredFields: ["product", "cta", "universitySlug"],
    },
    connectMeButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "universitySlug"],
    },
    messageLinkClicked: {
        name: "Link Clicked",
        requiredFields: ["product", "conversationId", "url", "universitySlug"],
    },
    emailCollectionVisible: {
        name: "Email Collection Visible",
        requiredFields: ["product", "universitySlug"],
    },
    emailCollectionSkipButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "where", "universitySlug"],
    },
    emailCollectionSubmitButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "where", "universitySlug"],
    },
    conversationRatingCollectionVisible: {
        name: "Conversation Rating Collection Visible",
        requiredFields: ["product", "universitySlug"],
    },
    conversationRatingContinueChattingButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "where", "universitySlug"],
    },
    conversationRatingSubmitButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "conversationRating", "cta", "where", "universitySlug"],
    },
    conversationFeedbackSkipButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "where", "universitySlug"],
    },
    conversationFeedbackSubmitButtonClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "where", "universitySlug"],
    },
    ambassadorRecommended: {
        name: "Ambassador Recommended",
        requiredFields: ["product", "conversationId", "buddyType", "universitySlug"],
    },
    assistantChatNowClicked: {
        name: "Assistant Chat Now Clicked",
        requiredFields: ["product", "conversationId", "buddyType", "universitySlug"],
    },
    sendMessageClicked: {
        name: "Button Clicked",
        requiredFields: ["product", "cta", "universitySlug"],
    },
};
